import { request } from "@umijs/max";

export const querySites = async (
  params: SiteAPI.SiteParams,
  options?: { [key: string]: any },
) => {
  return request<SiteAPI.SiteList>(
    '/v1/backoffice/authorization/x/uni/sites',
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: {
        action: 'query',
        page: params.current ? params.current : 1,
        pageSize: params.pageSize ? params.pageSize : 100,
        filter: {},
      },
      ...(options || {}),
    },
  );
};

// v1boauthorgsite.POST("/players/:id/transactions", handlers.HandlePlayerTransactions)
// v1boauthorgsite.POST("/revenue/:id/value/", handlers.HandleSiteRevenue)
/** Get Site Revenue - total balance of all players in the house */
export const getSitePortValue = (
  params: {
    current?: number;
    pageSize?: number;
    keyword?: string;
  },
  options: { [key: string]: any } = {},
) => {
  return request<{ data: SiteAPI.SiteRevenue }>(
    '/v1/backoffice/authorization/cs-org/port/val',
    {
      method: 'POST',
      params,
      ...(options || {}),
    }
  )
}

/** Get Service Prices - absolute cold money on house site (not tied to players) */
export async function queryServicePrices(
  siteId: number,
  options?: { [key: string]: any }
) {
  return request<SiteAPI.SiteBalance>(
    '/v1/backoffice/authorization/cs-org/service-prices',
    {
      method: 'GET',
      params: { site_id: siteId },
      ...(options || {}),
    }
  );
}



